<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
    [rowHover]="true" [showCurrentPageReport]="true" dataKey="name"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
    styleClass="p-datatable-striped">

    <!-- #region TABLE TITLE DEFINITION -->
    <ng-template pTemplate="caption">
        <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            {{ 'tableManagement.sinister.sinister' | translate }}
        </div>
    </ng-template>
    <!-- #endregion TABLE TITE DEFINITION -->

    <!-- #region TABLE COLUMN DEFINITION -->
    <ng-template pTemplate="header">
        <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            <!-- VEHICLE -->
            <th pSortableColumn='vehicle.name'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'general.vehicle' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='vehicle.name'></p-sortIcon>
                        <p-columnFilter field='vehicle' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- DRIVER -->
            <th pSortableColumn='driver.employee.user.surname1'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.driver' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='driver.employee.user.surname1'></p-sortIcon>
                        <p-columnFilter field='driver' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- REFERENCE NUMBER -->
            <th pSortableColumn='referenceNumber'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.referenceNumber' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='referenceNumber'></p-sortIcon>
                        <p-columnFilter field='referenceNumber' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- SINISTER TYPE -->
            <th pSortableColumn='sinisterType.name'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.sinisterTypeTable' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='sinisterType.name'></p-sortIcon>
                        <p-columnFilter field='sinisterType' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- SINISTER DATE -->
            <th pSortableColumn='sinisterDate'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.sinisterDate' | translate }}
                    </div>

                     <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="sinisterDate"></p-sortIcon>
                        <p-columnFilter field="sinisterDate" type="date" matchMode="contains"
                            placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- SINISTER TOTAL -->
            <th pSortableColumn='sinisterTotal'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.sinisterTotal' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='sinisterTotal'></p-sortIcon>
                        <p-columnFilter field='sinisterTotal' type='boolean' display='menu'
                            [showApplyButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- CLOSED -->
            <th pSortableColumn='closed'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.closed' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='closed'></p-sortIcon>
                        <p-columnFilter field='closed' type='boolean' display='menu'
                            [showApplyButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- DELETE -->
			<th class="button-column"></th>

        </tr>
    </ng-template>
    <!-- #endregion TABLE COLUMN DEFINITION -->

    <!-- #region TABLE BODY -->
    <ng-template pTemplate="body" let-sinister>
        <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="openDialog(sinister)">

            <!-- VEHICLE -->
            <td>
                {{ sinister.vehicle.name }}
            </td>

            <!-- DRIVER -->
            <td>
                {{ sinister.driver?.employee?.user?.surname1}} {{ sinister.driver?.employee?.user?.surname2}},  {{sinister.driver?.employee.user?.name }}
            </td>

            
            <!-- REFERENCE NUMBER -->
            <td>
                {{ sinister.referenceNumber }}
            </td>

            <!-- SINISTER TYPE -->
            <td>
                {{ sinister.sinisterType.name }}
            </td>

            <!-- SINISTER DATE -->
            <td>
                {{ sinister.sinisterDate | date: 'dd/MM/yyyy' }}
            </td>

            <!-- SINISTER TOTAL -->
            <td>
                <div class="d-flex justify-content-center align-items-center">
                    <i class="pi"
                        [ngClass]="{'true-icon pi-check-circle': sinister.sinisterTotal, 'false-icon pi-times-circle': !sinister.sinisterTotal}"></i>
                </div>
            </td>

            <!-- CLOSED -->

            <td [ngStyle]="{ 'background-color': sinister.closed ? 'red' : 'green' }">          
            </td>


            <!-- DELETE -->
			<td class="button-column">
				@if (isDeleteGranted) {
				<button type="button" class="btn custom-table-remove-button" (click)="onDeleteSinister(sinister)">
					<svg-icon
						src="assets/icons/trash.svg"
						class="d-flex flex-wrap custom-table-remove-button-icon"
						[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
					></svg-icon>
				</button>
				}
			</td>
        </tr>

    </ng-template>
    <!-- #endregion TABLE BODY -->

    <!-- #region TABLE EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE EMPTY MESSAGE -->

    <!-- #region TABLE FOOTER -->
    <ng-template pTemplate="footer">
        <tr>
            <td colspan="8" class="p-0">
                <div class="d-flex flex-row align-items-center p-3 gap-3">

                    <!-- ADD accessory BUTTON -->

                        @if (isCreateGranted) {
                        <app-table-add-button [text]=" 'tableManagement.sinister.sinister' | translate"
                        (btnClick)="create()"></app-table-add-button>
                        }
                   
                    

                    <!-- EXCEL BUTTON -->
                    <app-table-excel-button class="buttonTableExcel"  (btnClick)="exportExcel()"></app-table-excel-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE FOOTER -->

</p-table>

<!-- CARD TYPE FORM -->
<app-sinister-form [vehicle]="vehicle"></app-sinister-form>

<p-confirmDialog
	#saveEventDialog
	[header]="'confirm.critic' | translate"
	[message]="'control-panel.delete-dialog.message' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="sinister-list"
>
	<ng-template pTemplate="footer">
		<!-- REJECT BUTTON -->
		<button (click)="saveEventDialog.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<!-- ACCEPT BUTTON -->
		<button (click)="saveEventDialog.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>
